import { render, staticRenderFns } from "./servicetype.vue?vue&type=template&id=e5947350&"
import script from "./servicetype.vue?vue&type=script&lang=js&"
export * from "./servicetype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports